import { MbeAlert } from '@/components/icons';
import { Section } from '@/components/shared';
import { Flex, Icon, Text } from '@chakra-ui/react';
import { Trans, useTranslation } from 'react-i18next';

/**
 * PaymentError component
 * @returns {JSX.Element}
 */
export const PaymentError: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Section
      containerProps={{ py: 0, gap: { base: 8, md: 16 } }}
      headingProps={{ mt: 0 }}
      id="payment-error-section"
    >
      <Flex alignItems="center" direction="column" gap={4} px={{ base: 8, md: 16, xl: 44 }}>
        <Icon as={MbeAlert} h={24} w={24} />
        <Text fontSize={{ base: 'h1.base', md: 'h1.md' }} fontWeight="bold" textAlign="center">
          {t('WIZARD.PAYMENT.ERROR_TITLE')}
        </Text>
        <Text textAlign="center">
          <Trans i18nKey="WIZARD.PAYMENT.ERROR_CONTENT" />
        </Text>
      </Flex>
    </Section>
  );
};
